import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
} from './club-user.action';
import { Activity, ClubUser } from './club-user.model';

export interface ClubUserRecordsState {
    listData: any[];
    singleData: ClubUser;
    loading: boolean;
    error: any;

    activities: Activity[];
    activity_loading: boolean;
    activity_error: any;
    total: number;
}

export const initialState: ClubUserRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    
    activities: [],
    activity_loading: false,
    activity_error: null,
    total: 0,
};


export const clubUserRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData: listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);